import { Box, Button, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from '../../../store/menuSlice'
import time from '../../../assets/icons/e-learning/time.svg'
import book from '../../../assets/icons/e-learning/user/book.svg'
import { useNavigate } from 'react-router-dom'
import * as api from '../../services/api'
import styles from '../elearning.module.css'
import Loader from 'components/Loader'

function ManageUserELearning() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState('')

    const [category, setCategory] = useState('null')
    const [optionGroup, setOptionGroup] = useState([])

    const [courseList, setCourseList] = useState([])
    const [courseListAll, setCourseListAll] = useState([])

    const [historyAll, setHistoryAll] = useState([])
    const [historyFinishAll, setHistoryFinishAll] = useState([])

    useEffect(() => {
        dispatch(menuActive('E-Learning ทั้งหมด'))
    }, [])

    useEffect(() => {
        findCourse()
        myCourse()
    }, [])

    const handleClickSearch = () => {
        if (category === 'null') {
            if (search === '') {
                setCourseList(courseListAll)
            } else {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_name.toLowerCase().includes(search.toLowerCase())
                )
                setCourseList(filteredItems)
            }
        } else {
            if (search === '') {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_group_code.toLowerCase().includes(category.toLowerCase())
                )
                setCourseList(filteredItems)
            } else {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_name.toLowerCase().includes(search.toLowerCase()) && item.e_learning_group_code.toLowerCase().includes(category.toLowerCase())
                )
                setCourseList(filteredItems)
            }
        }
    }

    const findCourse = async () => {
        setLoading(true)
        let res = await api.findCourse()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data'].reverse()
                setCourseList(data)
                setCourseListAll(data)

                let option = []
                for (let i = 0; i < data.length; i++) {
                    if (data[i]) {
                        option.push({
                            key: data[i]['e_learning_group_code'],
                            value: data[i]['e_learning_group_name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()]
                    setOptionGroup(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const myCourse = async () => {
        setLoading(true)
        let res = await api.myCourse()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data'])
                const filteredItems = res['data']['data'].filter((item) =>
                    // item.finish_date == null
                    item.register_status == 'W' || item.register_status == 'N'
                )
                console.log('กำลังเรียน', filteredItems)
                setHistoryAll(filteredItems)

                const filteredItemsFinish = res['data']['data'].filter((item) =>
                    // item.finish_date !== null
                    item.register_status == 'S' || item.register_status == 'C' || item.register_status == 'F'
                )
                console.log('เรียนจบแล้ว', filteredItemsFinish)
                setHistoryFinishAll(filteredItemsFinish)

            } else {
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const handleClickStart = (i, index) => {
        // console.log(i)
        const filteredItems = courseListAll.filter((item) =>
            item.e_learning_code.includes(i['e_learning_code'])
        )
        const filteredtest = historyAll.filter((item) =>
            item.e_learning_code.includes(i['e_learning_code'])
        )

        console.log('filteredItems', filteredItems)
        console.log('filteredtest', filteredtest)

        if (filteredtest[0]['pre_test'] === false) {
            // || filteredtest[0]['pre_test'] === false || filteredtest[0]['pre_test_score'] === null
            navigate('/testBeforeClass', { state: { item: filteredItems[0], button: "1", register_number: filteredtest[0]['register_number'] } })
        } else {
            if (filteredtest[0]['start_course'] === false) {
                navigate('/testBeforeClass', { state: { item: filteredItems[0], button: "1", register_number: filteredtest[0]['register_number'] } })
            } else {
                navigate('/classroom', { state: { item: filteredItems[0], current: filteredtest[0]['progress_finish'], register_number: filteredtest[0]['register_number'] } })
            }
        }
    }

    const handleFilterGroup = (e) => {
        let { value } = e.target
        setCategory(value)

        if (search === '') {
            if (value === 'null') {
                setCourseList(courseListAll)
            } else {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_group_code.toLowerCase().includes(value.toLowerCase())
                )
                setCourseList(filteredItems)
            }
        } else {
            if (value === 'null') {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_name.toLowerCase().includes(search.toLowerCase())
                )
                setCourseList(filteredItems)
            } else {
                const filteredItems = courseListAll.filter((item) =>
                    item.e_learning_name.toLowerCase().includes(search.toLowerCase()) && item.e_learning_group_code.toLowerCase().includes(value.toLowerCase())
                )
                setCourseList(filteredItems)
            }
        }

    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>ยินดีต้อนรับสู่ห้องเรียนออนไลน์ !</Box>

                {historyAll.length > 0 ?
                    <Box sx={{
                        backgroundColor: '#EBF5FF',
                        padding: '10px',
                        display: 'grid',
                        gridGap: '10px',
                        overflow: 'auto'
                    }}>
                        <Typography>หลักสูตรที่ท่านยังเรียนไม่จบ พร้อมเข้าสู่หลักสูตรถัดไปหรือยัง ?</Typography>
                        <Box sx={{
                            display: 'flex',
                            gridGap: '10px'
                        }}>
                            {historyAll.map((item, index) => (
                                <Box sx={{
                                    border: '1px solid #2F327D1A',
                                    boxShadow: '2px 2px 10px #2F327D1A',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '10px',
                                    padding: '10px',
                                    width: '300px',
                                    display: 'grid',
                                    gridGap: '10px',
                                    cursor: 'pointer'
                                }}
                                    key={index}
                                    onClick={() => { handleClickStart(item, index) }}
                                >
                                    <Box sx={{
                                        width: '100%',
                                        height: '200px',
                                        "@media (max-width: 1000px)": {
                                            height: '150px',
                                        }
                                    }}>
                                        <img src={item['e_learning_image']} style={{ width: '100%', borderRadius: '10px', height: 'inherit', objectFit: 'cover' }} />
                                    </Box>
                                    <Box sx={{ fontWeight: 600 }}>{item['e_learning_name']}</Box>
                                    <Box sx={{
                                        width: '100%',
                                        backgroundColor: '#D9D9D9',
                                        height: '5px'
                                    }}>
                                        <Box sx={{
                                            width: (parseInt(item['finish_percentage'])) + '%',
                                            backgroundColor: '#49BBBD',
                                            height: '5px'
                                        }}>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                    :
                    <Box sx={{
                        backgroundColor: '#EBF5FF',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '250px'
                    }}>
                        <Typography sx={{ color: '#478F96' }}>ท่านยังไม่มีประวัติการเรียน</Typography>
                    </Box>

                }

                {historyFinishAll.length > 0 &&
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        "@media (max-width: 800px)": {
                            display: 'grid',
                            gridGap: '10px',
                            justifyContent: 'center'
                        }
                    }}
                    >
                        <Typography sx={{ color: '#49BBBD', cursor: 'pointer' }} onClick={() => { navigate('/viewAllHistory', { state: { item: historyFinishAll } }) }}>ดูประวัติการเรียนทั้งหมด</Typography>
                        <Box></Box>
                    </Box>
                }

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    display: 'flex',
                    padding: '5px'
                }}>
                    <TextField
                        fullWidth
                        variant="standard"
                        sx={{
                            ...InputCSS
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                        value={search}
                        onChange={(e) => { setSearch(e.target.value) }}
                    />
                    <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    "@media (max-width: 800px)": {
                        display: 'grid',
                        gridGap: '10px',
                        justifyContent: 'center'
                    }
                }}>
                    <Box>
                        <Select
                            size="small"
                            sx={{ ...SelectCss }}
                            value={category || "null"}
                            onChange={(e) => { handleFilterGroup(e) }}
                        >
                            <MenuItem value="null">หมวดหมู่ทั้งหมด</MenuItem>
                            {optionGroup.map((i, idx) => (
                                <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Box>

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridGap: '10px',
                    "@media (max-width: 1000px)": {
                        gridTemplateColumns: '1fr 1fr',
                    },
                    "@media (max-width: 600px)": {
                        gridTemplateColumns: '1fr',
                    }
                }}>
                    {courseList.map((item, index) => (
                        <Box sx={{
                            border: '1px solid #2F327D1A',
                            boxShadow: '2px 2px 10px #2F327D1A',
                            backgroundColor: '#ffffff',
                            borderRadius: '10px',
                            padding: '10px',
                            cursor: 'pointer',
                            display: 'grid',
                            gridGap: '5px'
                        }}
                            key={index}
                            onClick={() => { navigate('/showCourse', { state: item }) }}
                        >
                            <Box sx={{
                                width: '100%',
                                height: '200px',
                                "@media (max-width: 1000px)": {
                                    height: '150px',
                                }
                            }}>
                                <img src={item['e_learning_image']} style={{ width: '100%', borderRadius: '10px', height: 'inherit', objectFit: 'cover' }} />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <Box>
                                        <img src={book} />
                                    </Box>
                                    <Box>{item['properties'].length}บทเรียน</Box>
                                </Box>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <Box>
                                        <img src={time} />
                                    </Box>
                                    <Box>{item['e_learning_hour']} ชั่วโมง</Box>
                                </Box>
                            </Box>
                            <Box sx={{ fontWeight: 600 }}>{item['e_learning_name']}</Box>
                            <Box className={styles.ellipsis}>{item['e_learning_detail']}</Box>
                            <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                <Box sx={{ fontWeight: 600 }}>ผู้เข้าเรียน:</Box>
                                <Box>{item['register_total']} คน</Box>
                            </Box>
                        </Box>
                    ))}
                </Box>

            </Box>
        </>
    )
}

export default ManageUserELearning

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}